import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=55823bff&scoped=true&"
import script from "./breadcrumb.vue?vue&type=script&lang=ts&"
export * from "./breadcrumb.vue?vue&type=script&lang=ts&"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=55823bff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55823bff",
  null
  
)

component.options.__file = "breadcrumb.vue"
export default component.exports